export default {
  // copy of the official validation object
  // we don't use all the rules, but for simplicity and consistency
  // our custom rules in the end
  validation: {
    accepted: ":attribute igomba kwemerwa.",
    active_url: ":attribute si URL yemewe.",
    after: ":attribute igomba kuba itariki nyuma ya :date.",
    after_or_equal:
      ":attribute igomba kuba itariki nyuma cyangwa ingana na :date.",
    alpha: ":attribute igomba kuba igizwe n'inyuguti gusa.",
    alpha_dash:
      ":attribute igomba kuba igizwe n'inyuguti, imibare, utumenyetso two gukurura (-) n'utwo hasi (_).",
    alpha_num: ":attribute igomba kuba igizwe n'inyuguti n'imibare gusa.",
    array: ":attribute igomba kuba urutonde (array).",
    before: ":attribute igomba kuba itariki mbere ya :date.",
    before_or_equal:
      ":attribute igomba kuba itariki mbere cyangwa ingana na :date.",
    between: {
      numeric: ":attribute igomba kuba hagati ya :min na :max.",
      file: ":attribute igomba kuba hagati ya :min na :max kilobytes.",
      string: ":attribute igomba kuba hagati y'inyuguti :min na :max.",
      array: ":attribute igomba kugira ibintu biri hagati ya :min na :max.",
    },
    boolean: "Umwanya wa :attribute ugomba kuba ukuri cyangwa ikinyoma.",
    captcha: "Emeza ko utari robo.",
    completed: "Nyamuneka shyiramo nimero ya telefoni yemewe.",
    confirmed: "Kwemeza :attribute ntikuhuye.",
    date: ":attribute si itariki yemewe.",
    date_format: ":attribute ntabwo ihuye n'imiterere :format.",
    date_equals: ":attribute igomba kuba ingana na :date.",
    different: ":attribute na :other bigomba gutandukana.",
    digits: ":attribute igomba kuba imibare :digits.",
    digits_between:
      ":attribute igomba kuba imibare iri hagati ya :min na :max.",
    dimensions: ":attribute ifite ingano z'ishusho zitemewe.",
    distinct: "Umwanya wa :attribute ufite agaciro kigana.",
    email: ":attribute igomba kuba imeri yemewe.",
    exists: ":attribute yatoranyijwe ntiyemewe.",
    file: ":attribute igomba kuba dosiye.",
    filled: "Umwanya wa :attribute ugomba kugira agaciro.",
    gt: {
      numeric: ":attribute igomba kuba nkuru kuri :value.",
      file: ":attribute igomba kuba nini kurusha :value kilobytes.",
      string: ":attribute igomba kurenza inyuguti :value.",
      array: ":attribute igomba kugira ibintu birenze :value.",
    },
    gte: {
      numeric: ":attribute igomba kuba nkuru cyangwa ingana na :value.",
      file: ":attribute igomba kuba nini cyangwa ingana na :value kilobytes.",
      string:
        ":attribute igomba kugira inyuguti zingana cyangwa zirenze :value.",
      array: ":attribute igomba kugira ibintu :value cyangwa birenga.",
    },
    image: ":attribute igomba kuba ishusho.",
    in: ":attribute yatoranyijwe ntiyemewe.",
    in_array: "Umwanya wa :attribute ntuboneka muri :other.",
    integer: ":attribute igomba kuba umubare w'intagondwa (integer).",
    ip: ":attribute igomba kuba aderesi IP yemewe.",
    ipv4: ":attribute igomba kuba aderesi IPv4 yemewe.",
    ipv6: ":attribute igomba kuba aderesi IPv6 yemewe.",
    json: ":attribute igomba kuba umurongo wa JSON wemewe.",
    lt: {
      numeric: ":attribute igomba kuba nto kuri :value.",
      file: ":attribute igomba kuba nto kurusha :value kilobytes.",
      string: ":attribute igomba kuba munsi y'inyuguti :value.",
      array: ":attribute igomba kugira ibintu bitageze kuri :value.",
    },
    lte: {
      numeric: ":attribute igomba kuba nto cyangwa ingana na :value.",
      file: ":attribute igomba kuba nto cyangwa ingana na :value kilobytes.",
      string:
        ":attribute igomba kugira inyuguti zingana cyangwa zitageze kuri :value.",
      array: ":attribute ntigomba kugira ibintu birenze :value.",
    },
    max: {
      numeric: ":attribute ntishobora kuba nkuru kuri :max.",
      file: ":attribute ntishobora kurenga :max kilobytes.",
      string: ":attribute ntishobora kurenga inyuguti :max.",
      array: ":attribute ntishobora kugira ibintu birenze :max.",
    },
    mimes: ":attribute igomba kuba dosiye y'ubwoko: :values.",
    mimetypes: ":attribute igomba kuba dosiye y'ubwoko: :values.",
    min: {
      numeric: ":attribute igomba kuba nibura :min.",
      file: ":attribute igomba kuba nibura :min kilobytes.",
      string: ":attribute igomba kugira nibura inyuguti :min.",
      array: ":attribute igomba kugira nibura ibintu :min.",
    },
    not_in: ":attribute yatoranyijwe ntiyemewe.",
    not_regex: "Imiterere ya :attribute ntiyemewe.",
    numeric: ":attribute igomba kuba umubare.",
    present: "Umwanya wa :attribute ugomba kubamo.",
    regex: "Imiterere ya :attribute ntiyemewe.",
    required: "Umwanya wa :attribute urakenewe.",
    required_if: "Umwanya wa :attribute urakenewe iyo :other ari :value.",
    required_unless:
      "Umwanya wa :attribute urakenewe keretse :other iri muri :values.",
    required_with: "Umwanya wa :attribute urakenewe iyo :values ihari.",
    required_with_all:
      "Umwanya wa :attribute urakenewe iyo :values zose zihari.",
    required_without: "Umwanya wa :attribute urakenewe iyo :values idahari.",
    required_without_all:
      "Umwanya wa :attribute urakenewe iyo nta na rimwe muri :values rihari.",
    same: ":attribute na :other bigomba guhura.",
    size: {
      numeric: ":attribute igomba kuba :size.",
      file: ":attribute igomba kuba :size kilobytes.",
      string: ":attribute igomba kuba inyuguti :size.",
      array: ":attribute igomba kugira ibintu :size.",
    },
    string: ":attribute igomba kuba umurongo (string).",
    timezone: ":attribute igomba kuba akarere k'igihe kemewe.",
    unique: ":attribute yamaze gufatwa.",
    uploaded: ":attribute yananiwe koherezwa (upload).",
    url: "Imiterere ya :attribute ntiyemewe.",
    uuid: ":attribute igomba kuba UUID yemewe.",
    remote: "Umwanya wa :attribute ntiwemewe.",
    // our custom rules
    rwandaPhone:
      "Nimero ya telefoni yo mu Rwanda irakenewe ku bimenyetso bya SMS. Igomba kuba mu buryo 2507XXXXXXXX",
  },
};
